import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";
import fetchV2 from "../auth/FetchInterceptorV2";

const dashboardService = {};

dashboardService.getDonutChart = function () {
  return fetchV2({
    url: `${env.API_MSP}/dashboards/get-type-docs`,
    method: "get",
  });
};

dashboardService.getTotalDocs = function () {
  return fetchV2({
    url: `${env.API_MSP}/dashboards/get-total-docs`,
    method: "get",
  });
};

dashboardService.getTotalNotify = function () {
  return fetchV2({
    url: `${env.API_MSP}/dashboards/get-total-notifications`,
    method: "get",
  });
};

dashboardService.getStackedData = function () {
  return fetchV2({
    url: `${env.API_MSP}/dashboards/get-docs-expired`,
    method: "get",
  });
};

// Stats By Shipping Type
dashboardService.statsByShippingType = ({ payload }) => {
  return fetchV2({
    url: `${env.API_MSP}/dashboard/stats-by-shipping-type`,
    method: "get",
  });
};

// List Order Dashboard
dashboardService.statsByDvvc = params => {
  return fetchV2({
    url: `${env.API_MSP}/dashboard/stats-by-dvvc`,
    method: "get",
    params,
  });
};

dashboardService.statsByStatus = params => {
  return fetchV2({
    url: `${env.API_MSP}/dashboard/stats-by-status`,
    method: "get",
    params,
  });
};

// KPI đơn hàng theo tháng
dashboardService.statsByKpiPerformance = params => {
  return fetchV2({
    url: `${env.API_MSP}/dashboard/stats-by-kpi-performance`,
    method: "get",
    params,
  });
};

dashboardService.listOrderDashboard = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  return fetchV2({
    url: `${env.API_MSP}/${params.orderUrlPrefix}`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords,
    },
  });
};

export default dashboardService;
